import { useRef, useState } from "react";
import { UploadSimple, ImageSquare } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function UploadDropzone({ onFile }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const handleFile = (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Please upload an image file.");
      return;
    }
    if (file.size > 12 * 1024 * 1024) {
      toast.error("Image is too large (max 12MB).");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => onFile(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <button
      type="button"
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragging(false);
        handleFile(e.dataTransfer.files?.[0]);
      }}
      className={`group w-full max-w-xl flex flex-col items-center justify-center text-center p-8 sm:p-12 rounded-2xl border-2 border-dashed transition-all duration-300 cursor-pointer ${
        dragging
          ? "border-[color:var(--epx-primary)] bg-[rgba(34,197,94,0.08)]"
          : "border-white/15 hover:border-[color:var(--epx-primary)]/50 hover:bg-white/[0.03]"
      }`}
      data-testid="upload-dropzone"
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => handleFile(e.target.files?.[0])}
        data-testid="upload-input"
      />
      <div
        className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4 transition-colors"
        style={{
          background: "rgba(var(--epx-primary-rgb),0.14)",
          color: "var(--epx-primary)",
        }}
      >
        <UploadSimple size={28} weight="duotone" />
      </div>
      <p className="overline">Step 01</p>
      <p className="font-heading text-xl sm:text-2xl font-semibold mt-2 text-white">
        Drop a photo of your floor
      </p>
      <p className="text-sm text-zinc-400 mt-2 max-w-sm">
        JPG or PNG up to 12MB. Best results: a clear, well-lit photo of the
        floor area you want coated.
      </p>
      <div className="flex items-center gap-2 mt-5 text-xs text-zinc-500 font-mono-tech">
        <ImageSquare size={14} />
        garage · driveway · basement · room
      </div>
    </button>
  );
}
